import { render, staticRenderFns } from "./ItemBundle.vue?vue&type=template&id=4a0735cf&"
import script from "./ItemBundle.vue?vue&type=script&lang=js&"
export * from "./ItemBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0735cf')) {
      api.createRecord('4a0735cf', component.options)
    } else {
      api.reload('4a0735cf', component.options)
    }
    module.hot.accept("./ItemBundle.vue?vue&type=template&id=4a0735cf&", function () {
      api.rerender('4a0735cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemBundle.vue"
export default component.exports